export default "__VITE_ASSET__SwCH7xJg__"